module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    attrs: {
      "id": "container"
    }
  }, [_vm._t("video"), _vm._v(" "), _c('div', {
    ref: "articleWrap",
    attrs: {
      "id": "articles"
    }
  }, [_c('logo'), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.quitEpisode()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "height": "24px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "24px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
    }
  })])]), _vm._v(" "), _vm._t("components")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f84bb5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/episodes/Wrapper.vue
// module id = 704
// module chunks = 64